import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var ModalWizardStep = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
ModalWizardStep.defaultProps = {
    showProgressBar: true,
    countsAsProgress: true
};
export { ModalWizardStep };

//# sourceMappingURL=ModalWizardStep.js.map